/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../../../_metronic/_partials/controls";

export function HewanKurbanEditDialogHeader({ id }) {

    const [title, setTitle] = useState("");
    // Channel Redux state
    const { hewanKurbanForEdit, actionsLoading } = useSelector(
        (state) => ({
            hewanKurbanForEdit: state.hewanKurbans.hewanKurbanForEdit,
            actionsLoading: state.channels.actionsLoading,
        }),
        shallowEqual
    );

    useEffect(() => {
        let _title = id ? "" : "Kategori Hewan Baru";
        if (hewanKurbanForEdit && id) {
            _title = "Edit Kategori Hewan";
        }

        setTitle(_title);
        // eslint-disable-next-line
    }, [hewanKurbanForEdit, actionsLoading]);

    return (
        <>
            {actionsLoading && <ModalProgressBar variant="query" />}
            <Modal.Header closeButton>
                <Modal.Title id="modal-sizes-title-lg">{title}</Modal.Title>
            </Modal.Header>
        </>
    );
}
